/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Invitation_Email_UsedInputs */

const fr_error_invitation_email_used = /** @type {(inputs: Error_Invitation_Email_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette adresse email est déjà utilisée par un autre compte. Demandez une nouvelle invitation à un administrateur.`)
};

const en_error_invitation_email_used = /** @type {(inputs: Error_Invitation_Email_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Another account already uses this email address. Ask an administrator for a new invitation.`)
};

/**
* | output |
* | --- |
* | "Another account already uses this email address. Ask an administrator for a new invitation." |
*
* @param {Error_Invitation_Email_UsedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const error_invitation_email_used = /** @type {((inputs?: Error_Invitation_Email_UsedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Invitation_Email_UsedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_invitation_email_used(inputs)
	return fr_error_invitation_email_used(inputs)
});